// extracted by mini-css-extract-plugin
export default {"block":"ui_block__-Di3D","iconWrapper":"ui_iconWrapper__fBkcX","text":"ui_text__lOtqo"};